<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="reportingLogType in reportingLogTypes">
                    <td>
                        <input type="text" v-if="reportingLogType.editable" class="form-control" :name="reportingLogType.value" v-model="form['value'][reportingLogType.id]">
                        <span v-if="!reportingLogType.editable">{{ reportingLogType.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeReportingLogType(reportingLogType)" class="btn btn-danger" v-if="reportingLogType.deleteable" :title="uLang('app.delete_reporting_log')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newReportingLogType" :placeholder="uLang('app.create_entity', { entity: lang('app.reporting_log_type')})" :title="uLang('app.add_new_reporting_log_type')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addReportingLogType" :disabled="form.busy">{{ uLang('app.create_entity', { entity: lang('app.reporting_log_type')}) }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'ReportingLogTypes',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newReportingLogType: '',
                reportingLogTypes: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.entity_updated', { entity: lang('app.reporting_log_types')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.reportingLogTypes = data;

                data.forEach(function (reportingLogType){
                    if(reportingLogType.editable){
                        this.value[reportingLogType.id] = reportingLogType.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addReportingLogType() {
                if (this.newReportingLog === '')
                    return;

                this.reportingLogTypes.push(
                    {
                        id: this.newReportingLogType,
                        value: this.newReportingLogType,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newReportingLogType] = this.newReportingLogType;
                this.newReportingLogType = '';
            },

            removeReportingLogType(reportingLogType) {
                new DestroyAlert({
                    text: this.lang('app.delete_warning_entity', { entity: this.lang('app.reporting_log_type') })
                }).show().then(async () => {
                    delete this.form.value[reportingLogType.id];

                    //remove the reportingLog from the table
                    this.reportingLogTypes = this.reportingLogTypes.filter(function (current_reporting_log_type) {
                        return current_reporting_log_type.value != reportingLogType.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>
